module.exports = __webpack_public_path__ + "static/media/mukul-jain.87c2e5cf.png";